
(function () {
  if (customElements.get('silo-how-stack')) return;

  class SiloHowStack extends HTMLElement {
    connectedCallback() {
      this.scrollers = Array.from(
        this.querySelectorAll('.t-overflow-x-auto.t-scrollbar-none')
      );
      if (this.scrollers.length < 2) return;

      this.thumb = this.querySelector('#customScrollThumb');
      this.active = null;
      this.rafId = null;
      this.controller = new AbortController();
      const { signal } = this.controller;

      const setActive = (el) => () => { this.active = el; };
      const clearActive = () => { this.active = null; };

      this.scrollers.forEach((el) => {
        el.addEventListener('pointerdown', setActive(el), { passive: true, signal });
        el.addEventListener('touchstart', setActive(el), { passive: true, signal });
        el.addEventListener('wheel', setActive(el), { passive: true, signal });
        el.addEventListener('scroll', () => {
          // Ignore scrolls we triggered programmatically on the inactive scrollers.
          if (!this.active) this.active = el;
          if (this.active !== el) return;
          this._requestSync(el);
        }, { passive: true, signal });
        el.addEventListener('pointerup', clearActive, { passive: true, signal });
        el.addEventListener('touchend', clearActive, { passive: true, signal });
        el.addEventListener('mouseleave', clearActive, { passive: true, signal });
      });

      this._requestSync(this.scrollers[0]); // set the initial thumb position
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      if (this.rafId) cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }

    _progress(el) {
      const max = Math.max(1, el.scrollWidth - el.clientWidth);
      return el.scrollLeft / max;
    }

    _requestSync(source) {
      if (this.rafId) cancelAnimationFrame(this.rafId);
      this.rafId = requestAnimationFrame(() => {
        const p = this._progress(source);

        this.scrollers.forEach((el) => {
          if (el === source) return;
          const max = Math.max(1, el.scrollWidth - el.clientWidth);
          const target = p * max;
          if (Math.abs(el.scrollLeft - target) > 0.5) el.scrollLeft = target;
        });

        if (this.thumb && this.thumb.parentElement) {
          const range = Math.max(0, this.thumb.parentElement.clientWidth - this.thumb.offsetWidth);
          this.thumb.style.transform = 'translateX(' + p * range + 'px)';
        }

        this.rafId = null;
      });
    }
  }

  customElements.define('silo-how-stack', SiloHowStack);
})();
